export enum UserType {
  Support = 'support',
  OrgAdmin = 'org_admin',
  Member = 'member',
}
